<template>
  <div class="grid-container">
    <div class="avatar">
      <b-carousel
        :indicator="false"
        :autoplay="false"
        icon-size="is-small"
        v-model="avatar"
        @change="avatar = $event"
        :indicator-inside="false"
        :arrow="true"
        :arrow-both="false"
        :arrow-hover="false"
      >
        <b-carousel-item
          v-for="(avatarUrl, i) in avatars"
          :key="i"
          class="carr-item"
        >
          <figure class="image is-128x128">
            <img :src="avatarUrl" alt="avatar" class="background-third" />
          </figure>
        </b-carousel-item>
      </b-carousel>
    </div>
    <div class="title"><h2>PLAY</h2></div>
    <img
      v-if="!kgames.username"
      src="/button.png"
      class="kgames rounded"
      @click="kgamesAuth()"
    />
    <div v-else class="kgames d-flex">
      <b-tooltip
        :label="
          kgames.authorizations.includes('un_premium')
            ? 'Premium'
            : 'non-Premium'
        "
        type="is-dark"
      >
        <b-icon
          icon="star-circle"
          :type="
            kgames.authorizations.includes('un_premium')
              ? 'is-warning'
              : 'is-dark'
          "
        />
      </b-tooltip>
      <h3>{{ kgames.username }}</h3>
      <img
        :src="kgames.profilePicture"
        style="height: 34px; border-radius: 5px"
      />
    </div>
    <div class="inputs">
      <b-input
        type="text"
        placeholder="Enter your name"
        class="name"
        v-model="name"
        maxlength="15"
        minlength="3"
      />
      <b-button
        type="is-primary"
        class="public"
        size="is-large"
        @click="
          joinRoomById(join, options);
          preventDoubleClick = true;
        "
        :disabled="!pseudoSanitized || preventDoubleClick || !join"
        expanded
        >Join game</b-button
      >
      <b-button
        type="is-primary"
        class="private"
        @click="createRoom('my_room', options)"
        :disabled="!pseudoSanitized"
        expanded
        >Create Private Game</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import queryString from "query-string";
import Cookies from "js-cookie";

export default {
  data: () => ({
    join: undefined,
    name: "",
    avatar: 0,
    preventDoubleClick: false
  }),
  methods: {
    kgamesAuth() {
      window.location.replace(
        `https://kgames.fr/auth?retUri=${window.location.href}`
      );
    }
  },
  mounted() {
    this.join = queryString.parse(location.search).join;
  },
  computed: {
    ...mapState(["avatars", "kgames"]),
    options() {
      return {
        name: this.name,
        avatar: this.avatar,
        token: Cookies.get("token")
      };
    },
    pseudoSanitized() {
      return this.name.length > 3;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/palette.scss";

.grid-container {
  background-color: $intru-2-hex;
  height: 500px;
  width: 400px;
  display: grid;
  grid-template-columns: 0.7fr 1.6fr 0.7fr;
  grid-template-rows: repeat(4, 1fr);
  gap: 5px 5px;
  grid-template-areas: ". title ." ". avatar ." ". kgames ." "inputs inputs inputs";
  justify-items: center;
  align-items: center;
  border-radius: 5px;
  @media only screen and (max-width: 800px) {
    width: auto;
  }
}

.kgames {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  background-color: #af8eb9;
  width: 100%;
  grid-area: kgames;
  cursor: pointer;
  border-radius: 5px;
}

.avatar {
  grid-area: avatar;
}

.title {
  grid-area: title;
  margin-top: 20%;
}

.inputs {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  grid-area: inputs;
}

.name {
  grid-area: name;
}

.public {
  grid-area: public;
  margin-bottom: 10px;
  background-color: $intru-4-hex;
}

.private {
  grid-area: private;
}

.background-third {
  background-color: $intru-3-hex;
  border-radius: 5px;
}

.carr-item {
  width: 150%;
  height: 150%;
}
</style>
